import useFetchData from "../../hooks/useFetchData";
import FSendApi from "../FSendApi";
import { v4 as uuidv4 } from "uuid";
import { useUser } from "./UserAuthProvider";

const { createContext, useState, useContext, useEffect, useRef, useCallback } = require("react");

const DeviceListContext = createContext();

const testDevice = [
  { name: "Eleven的小米14", address: "http://192.168.31.10:2333", id: "0" },
  { name: "测试用的的小米14", address: "http://192.168.31.11:2333", id: "1" },
];

export function DeviceListProvider({ children }) {
  const [deviceList, setDeviceList] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const { data, error, fetchData } = useFetchData();
  const [updateListCount, setUpdateListCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const wsRef = useRef(null);
  const userRef = useRef(null);
  const [deviceId] = useState(() => {
    let localId = localStorage.getItem("device-id");
    if (!localId) {
      localId = "web-" + uuidv4();
      localStorage.setItem("device-id", localId);
    }
    return localId;
  });

  const user = useUser();

  useEffect(() => {
    userRef.current = user;
  }, [user]);

  const sendDeviceInfo = useCallback((ws) => {
    if (!ws || ws.readyState !== WebSocket.OPEN) {
      return;
    }
    const token = userRef.current && userRef.current.user && userRef.current.user.token ? userRef.current.user.token : "";
    ws.send(
      JSON.stringify({
        type: "deviceInfo",
        data: {
          deviceType: "web",
          deviceId: deviceId,
          token,
        },
      })
    );
  }, [deviceId]);

  function fetchDeviceList() {
    if (isConnected) {
      fetchData(`${FSendApi.url}/api/deviceList?userId=${user && user.user ? user.user.id : ""}`);
    }
  }

  useEffect(() => {
    if (isConnected) {
      fetchData(`${FSendApi.url}/api/deviceList?userId=${user && user.user ? user.user.id : ""}`);
    }
  }, [isConnected, fetchData, updateListCount, user]);

  useEffect(() => {
    console.log("data:");
    console.log(data);
    if (error) {
      setDeviceList([]);
    } else {
      if (data != null && data.code === 0 && data.deviceList) {
        setDeviceList(data.deviceList);
      } else {
        setDeviceList([]);
      }
    }
    if (data != null || error != null) {
      setLoading(false);
    }
  }, [data, error]);

  useEffect(() => {
    function connectWebSocket() {
      console.log(`${FSendApi.ws}`);
      const ws = new WebSocket(`${FSendApi.ws}`);
      wsRef.current = ws;

      ws.onopen = () => {
        console.log("Websocket connection opened");
        setIsConnected(true);
        // 发送设备信息（包含最新登录token）
        sendDeviceInfo(ws);
      };

      ws.onmessage = (event) => {
        const data = event.data;
        console.log("server message:" + data);
        try {
          const msg = JSON.parse(data);
          if (msg.type === "ping") {
            ws.send(JSON.stringify({ type: "pong" }));
          } else if (msg.type === "updateDeviceList") {
            setUpdateListCount((prev) => {
              return prev + 1;
            });
          }
        } catch (error) {}
      };

      ws.onclose = () => {
        console.log("WebSocket connection closed");
        setIsConnected(false);
        if (wsRef.current === ws) {
          wsRef.current = null;
        }
        setTimeout(() => {
          connectWebSocket(); // 重连机制
        }, 2000); // 1秒后重连
      };

      ws.onerror = (error) => {
        console.error("WebSocket error", error);
        ws.close();
      };
    }

    connectWebSocket();
  }, [sendDeviceInfo]);

  useEffect(() => {
    // 登录/登出后重新上报deviceInfo，让服务端刷新user-device绑定
    if (isConnected && wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      sendDeviceInfo(wsRef.current);
    }
  }, [isConnected, user, sendDeviceInfo]);

  return (
    <DeviceListContext.Provider value={{ deviceList, fetchDeviceList, loading, deviceId }}>
      {children}
    </DeviceListContext.Provider>
  );
}

export const useDeviceList = () => useContext(DeviceListContext);
